// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"828":"92c8aecd","4599":"92c8aecd","5331":"21364858","6285":"799cacee","7543":"92c8aecd"}[chunkId] + ".css";
};